module.exports = __webpack_public_path__ + "75bc8d839018c98469f2af9a2e3dac21.png";


//////////////////
// WEBPACK FOOTER
// ./js/img/LOVD-hires.png
// module id = 1337
// module chunks = 0